'use client';

import { Drawer } from '@/shared-ui/molecules/drawer';
import type { ShopperProducts } from '@/scapi';
import { useRef, useState } from 'react';
import { DrawerContent, NavContent, type SubmenuPanelItem, type MegaMenuNavItem } from './ui';

type MegaMenuProps = {
    items: MegaMenuNavItem[];
    submenuPanels: SubmenuPanelItem[];
    rootCategory?: Promise<ShopperProducts.schemas['Category']>;
    shopAllLabel?: string;
    defaultDesktopItem?: string;
};

export type { MegaMenuNavItem, SubmenuPanelItem };

export const MegaMenu = ({
    items,
    submenuPanels,
    rootCategory,
    shopAllLabel = 'Shop all',
    defaultDesktopItem,
}: MegaMenuProps) => {
    const navContainerRef = useRef<HTMLDivElement>(null);
    const firstSubmenuItem = items.find((item) => item.link === false)?.id;
    const [activeDesktopItem, setActiveDesktopItem] = useState<string | undefined>(
        defaultDesktopItem ?? firstSubmenuItem
    );
    const [drawerOpen, setDrawerOpen] = useState(false);

    const handleDesktopItemChange = (itemId: string) => {
        setActiveDesktopItem((prevActiveItem) => (prevActiveItem === itemId ? undefined : itemId));
    };

    return (
        <Drawer.Root open={drawerOpen} onOpenChange={setDrawerOpen}>
            <div ref={navContainerRef} className="w-full">
                <NavContent
                    items={items}
                    activeDesktopItem={activeDesktopItem}
                    setActiveDesktopItem={handleDesktopItemChange}
                    closeSubmenuPanel={() => setActiveDesktopItem(undefined)}
                    submenuPanels={submenuPanels}
                    shopAllLabel={shopAllLabel}
                    ignorePanelCloseRefs={[navContainerRef]}
                />
            </div>
            <DrawerContent rootCategory={rootCategory} open={drawerOpen} onOpenChange={setDrawerOpen} />
        </Drawer.Root>
    );
};
